/**
 * What the welcome page reads without a session (`/api/public`).
 *
 * The plain `fetch`, never `apiFetch`: nobody is signed in on the page that
 * asks, and nothing here may send a visitor to sign in.
 */

/**
 * How many rooms Optivo prices, or null where there is no count to state.
 *
 * It never throws. The welcome page states the count in public, so it is drawn
 * only from an answer that is one, a whole number above zero. A request that
 * fails, an API from before the route existed and an answer that holds
 * anything else all read as no count, and the page then says nothing.
 */
export async function fetchPricedRoomsCount(): Promise<number | null> {
    try {
        const res = await fetch("/api/public/priced-rooms");
        if (!res.ok) return null;
        const data: unknown = await res.json();
        if (typeof data !== "object" || data === null) return null;
        const { success, pricedRooms } = data as { success?: unknown; pricedRooms?: unknown };
        if (success !== true) return null;
        return typeof pricedRooms === "number" && Number.isInteger(pricedRooms) && pricedRooms > 0
            ? pricedRooms
            : null;
    } catch {
        return null;
    }
}
